
<div class="circular-loading-bar-container">
  <svg class="circular-loading-bar" :width="64" :height="64" viewBox="0 0 36 36">
    <path
      class="circle-bg"
      d="M18 2.0845
         a 15.9155 15.9155 0 0 1 0 31.831
         a 15.9155 15.9155 0 0 1 0 -31.831"
      fill="none"
      stroke="#e0e0e0"
      stroke-width="0.5"
    />
    <path
      class="circle"
      :d="circlePath"
      fill="none"
      stroke="#4D84FF"
      stroke-width="1"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="strokeDashoffset"
      stroke-linecap="round"
    />
  </svg>
  <img class="center-image" :src="iconImgPath" alt="Center Image">
</div>
